<template>
  <div class="home">
    <header>
      <p>{{serversName}} {{userinfo.name}}</p>
      <div class="lang" @click="changeLang"></div>
    </header>
    <div class="content">
      <div
        class="logo"
        v-show="!resultFlag"
        :style="{ 'background-image': `url(${$t('home.logo')})` }"
      ></div>
      <div class="home-bottom" v-show="!descriptionFlag&&!resultFlag">
        <div class="reward">
          <div class="exclusive" @click="getExclusiveReward">{{$t('home.reward')}}</div>
          <div class="limited" @click="getLimitedWelfare">{{$t('home.welfare')}}</div>
        </div>
        <div class="up" @click="up">
          <div class="up-content">
            <div>{{$t('home.up')}}</div>
          </div>
        </div>
      </div>
      <div class="description" v-show="descriptionFlag">
        <img src="../../assets/images/down.png" alt @click="down" />
        <div class="description-content" v-if="$t('home.activity.time')">
          <h1>{{$t('home.activity.time.title')}}</h1>
          <p class="time">
            <span>{{$t('home.activity.time.year_start')}}</span>
            <span>{{$t('home.activity.time.month_day_start')}}</span>
            <span>—</span>
            <span>{{$t('home.activity.time.year_end')}}</span>
            <span>{{$t('home.activity.time.month_day_end')}}</span>
          </p>
          <h1>{{$t('home.activity.content.title')}}</h1>
          <p
            class="activity-way"
            v-html="item"
            v-for="(item,index) in $t('home.activity.content.way')"
            :key="index"
          >{{item}}</p>
        </div>
      </div>
    </div>
    <div class="mask" v-show="descriptionFlag"></div>
    <Result :type="type" :visibilityFlag.sync="resultFlag" :message="messageFailed" />
    <Lang :visibilityFlag.sync="langFlag" />
  </div>
</template>

<script>
import { value, onMounted } from "vue-function-api";
import Result from "../../components/modal";
import Lang from "../../components/lang";
import axios from "../../utils/axios";
import session from "../../utils/session";
import i18n from "../../locales/index"
import { LOCALE_MAP_2B } from "../../utils/constants";

export default {
  components: {
    Result,
    Lang
  },
  setup(props, context) {
    const {
      root: { $i18n }
    } = context;
    const startY = value(0);
    const descriptionFlag = value(false);
    const resultFlag = value(false);
    const messageFailed = value("");
    const type = value(true);
    const userinfo = value({});
    const langFlag = value(false);
    const serversName = value("");
    const changeLang = () => {
      langFlag.value = true;
    };
    const up = () => {
      descriptionFlag.value = true;
    };
    const getLimitedWelfare = () => {
      context.root.$router.push({
        path: "/welfare"
      });
    };
    //获取专属奖励
    const getExclusiveReward = async () => {
      if (userinfo.value.isNormalRewarded) {
        //是否已领取专属礼物
        type.value = false;
        messageFailed.value = i18n.t("messageFailed");
      } else {
        let { code, data } = await axios.postForm("/linkage_event/reward", {
          code: "",
          type: "normal"
        });
        if (code === 200) {
          type.value = true;
        } else {
          type.value = false;
          
          messageFailed.value = $i18n.te(`network_error.${data.error}`) ? 
              $i18n.t(`network_error.${data.error}`)
              :
              (  session.getString("token") ? 
                    $i18n.t(`network_error.OTHER`) : $i18n.t(`network_error.NO_TOKEN`)
              )
        }
      }
      resultFlag.value = true;
    };
    const down = () => {
      descriptionFlag.value = false;
      document.getElementsByClassName("description-content")[0].scrollTop = 0;
    };
    onMounted(async () => {
      //获取用户信息
      let { code, data } = await axios.get("/linkage_event/status");
      if (code === 200) {
        userinfo.value = data;
        session.setObject("userinfo", data);
        serversName.value =
          data.serversName[data.zone][
            LOCALE_MAP_2B[$i18n.locale]
          ];
      }
    });
    return {
      startY,
      getLimitedWelfare,
      getExclusiveReward,
      serversName,
      down,
      descriptionFlag,
      type,
      resultFlag,
      messageFailed,
      userinfo,
      changeLang,
      langFlag,
      up
    };
  }
};
</script>

<style lang="scss" scoped>
// $u: 0.01333333334;
// $h: $u * 190rem;
// .home {
//   width: 100%;
//   background: url("../../assets/images/home_background.png") center no-repeat;
//   background-size: 100% 100%;
//   padding-top: $u * 48rem;
//   position: relative;
//   box-sizing: border-box;
//   position: relative;
//   height: calc(100vh - #{$h});
//   padding-top: $u * 100rem;
//   header {
//     width: 100%;
//     height: $u * 100rem;
//     background: url("../../assets/images/header.png") center no-repeat;
//     background-size: 100% 100%;
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     padding: 0 $u * 40rem;
//     box-sizing: border-box;
//     position: fixed;
//     top: 0;
//     p {
//       margin: 0;
//       font-size: $u * 32rem;
//       color: #f7e5d2;
//       font-weight: bold;
//     }
//     .lang {
//       width: $u * 54rem;
//       height: $u * 54rem;
//       background: url("../../assets/images/lang.png") center no-repeat;
//       background-size: 100% 100%;
//     }
//   }
//   .content {
//     z-index: 1000;
//     width: 100%;
//     height: calc(100% - #{$u * 148rem});
//     position: absolute;
//     .logo {
//       width: $u * 496rem;
//       height: $u * 98rem;
//       // background: url("../../assets/images/logo.png") center no-repeat;
//       background-size: 100% 100%;
//       margin: 0 auto;
//       margin-top: $u * 24rem;
//     }
//     .home-bottom {
//       position: absolute;
//       bottom: 0;
//       display: flex;
//       flex-direction: column;
//       align-items: center;
//       width: 100%;
//       .reward {
//         margin-bottom: $u * 20rem;
//         display: flex;
//         .exclusive,
//         .limited {
//           width: $u * 306rem;
//           height: $u * 94rem;
//           background: url("../../assets/images/btn_back.png") center no-repeat;
//           background-size: 100% 100%;
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           font-size: $u * 52rem;
//           color: #4c2d1a;
//           font-weight: 800;
//         }
//         .exclusive {
//           margin-right: $u * 20rem;
//         }
//       }
//       .up {
//         width: 100%;
//         height: $u * 148rem;
//         background: url("../../assets/images/up_background.png") center no-repeat;
//         background-size: 100% 100%;
//         display: flex;
//         justify-content: center;
//         position: relative;
//         .up-content {
//           width: $u * 380rem;
//           height: $u * 26rem;
//           background: url("../../assets/images/up.png") center no-repeat;
//           background-size: 100% 100%;
//           position: absolute;
//           bottom: $u * 25rem;
//           div {
//             font-size: $u * 32rem;
//             font-weight: 800;
//             color: rgba(53, 25, 5, 1);
//             text-align: center;
//             position: relative;
//             bottom: $u * 10rem;
//           }
//         }
//       }
//     }
//     .description {
//       margin-top: $u * 50rem;
//       width: 100%;
//       height: calc(100vh - #{$u * 386rem});
//       background: url("../../assets/images/description_back.png") center no-repeat;
//       background-size: 100% 100%;
//       text-align: center;
//       padding: $u * 130rem 0 $u * 32rem 0;
//       box-sizing: border-box;
//       position: relative;
//       overflow: scroll;
//       touch-action: none;
//       img {
//         width: $u * 66rem;
//         height: $u * 28rem;
//         margin-bottom: $u * 20rem;
//         position: absolute;
//         top: $u * 56rem;
//         left: $u * 342rem;
//       }
//       .description-content {
//         width: 100%;
//         padding: 0 $u * 112rem 0 $u * 112rem;
//         box-sizing: border-box;
//         text-align: left;
//         height: 100%;
//         overflow: scroll;
//         p {
//           margin: 0;
//         }
//         h1 {
//           color: #351905;
//           font-size: $u * 32rem;
//           line-height: $u * 50rem;
//           position: relative;
//           margin: 0;
//           margin-bottom: $u * 10rem;
//           &::before {
//             content: "";
//             width: $u * 14rem;
//             height: $u * 14rem;
//             background: url("../../assets/images/circle.png");
//             background-size: 100% 100%;
//             position: absolute;
//             top: $u * 18rem;
//             left: -$u * 26rem;
//           }
//         }
//         .time {
//           color: #351905;
//           font-size: $u * 24rem;
//           line-height: $u * 50rem;
//           margin: 0;
//           margin-bottom: $u * 60rem;
//           span:nth-of-type(2),
//           span:nth-of-type(5) {
//             color: #89230f;
//             font-weight: 800;
//           }
//         }
//         .activity-way {
//           color: #351905;
//           font-size: $u * 24rem;
//           line-height: $u * 50rem;
//           margin: 0;
//           span {
//             color: #89230f;
//             font-weight: 800;
//           }
//         }
//       }
//     }
//   }
//   .mask {
//     z-index: 1;
//     width: 100%;
//     position: absolute;
//     top: 0;
//     left: 0;
//     bottom: 0;
//     right: 0;
//     background: url("../../assets/images/mask.png") center no-repeat;
//     background-size: 100% 100%;
//   }
// }
</style>